import { useTranslation } from "react-i18next";

import { Card, Divider, Flex, Row, Space, Button, Spin } from "antd";
import ModalSignature from "components/elements/Modal/ModalSignature";

import { groupBy } from "utils/helper";
import myStyles from "../styles/CompanyDocument.module.css";
import styles from "../styles/CompanyProfile.module.css";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"

function CompanyDocumentView({
  currentDocument = {},
  currentSignature = {},
  employeeOptions = [],
  isViewCertificate = false,
  onEdit = () => { },
  onView = () => { },
  onCancelSignature = () => { },
  getBase64,
  isLoading,
  isLoadingData
}) {
  const { t, i18n } = useTranslation();
  const { documentTemplateResponse = {}, documentSignatureResponse = {} } =
    currentDocument;
  const { roles } = useSelector((state) => state.company);
  console.log("documentTemplateResponse", documentTemplateResponse);
  function fnPic(params) {
    console.log("params", params);
    if (params) {
      const decodedString = atob(params);
      let bytes = new Uint8Array(decodedString.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = decodedString.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: 'image/png' });
      console.log("blob", blob);
      return blob;
    }
  }


  function createImageUrl(base64Data, contentType) {
    return `data:${contentType};base64,${base64Data}`;
  }

  return (
    <>
      <ModalSignature
        isModalOpen={isViewCertificate}
        initialValues={currentSignature}
        employeeOptions={employeeOptions}
        onCancel={onCancelSignature}
      />
      <Spin spinning={isLoading || isLoadingData}>
        <Space className={styles.container} size={24} direction="vertical">
          {
            roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|DOCUMENT") &&
            <Row justify="end" className={styles.container}>
              <Button onClick={onEdit} type="primary"
                style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
              >
                <Flex align="center" justify="center" gap={8}>
                  <EditIcon />
                  {t("common.edit").toUpperCase()}
                </Flex>
              </Button>
            </Row>
          }

          <Card style={{ border: "solid 1px #EAECF0" }}>
            <b className={styles.infoTopic}>
              {t("document.label.document_template")}
            </b>
            <Divider />
            <div className={myStyles.withdrawalContainer}>
              <label>{t("document.label.type_of_slip")}</label>
              <p>
                {documentTemplateResponse.typeOfSlip
                  ? i18n.language === "en"
                    ? documentTemplateResponse.slipNameEn
                    : documentTemplateResponse.slipName
                  : "-"}
              </p>
              <label>{t("document.label.size")}</label>
              <p>{documentTemplateResponse.paySlipSize || "-"}</p>
              <label>{t("document.label.seal_logo")}</label>
              <div className={myStyles.sealContainer} >
                <img
                  src={createImageUrl(documentTemplateResponse?.sealLogo, "image/png")}
                  alt=""
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              </div>

            </div>
          </Card>
          <Card style={{ border: "solid 1px #EAECF0" }}>
            <b className={styles.infoTopic}>
              {t("document.label.document_signature")}
            </b>
            <Divider />
            <div className={myStyles.documentSignatureContainer}>
              <p>
                <b>{t("document.label.document_type")}</b>
              </p>
              <p>
                <b>{t("document.label.authorize")}</b>
              </p>
              <p>
                <b>{t("document.label.signature")}</b>
              </p>
              {(
                Object.values(
                  groupBy(documentSignatureResponse, "documentTypeName")
                ) || []
              ).map((resp = []) => {
                return resp.map((signatureResp, idx) => {
                  const { authorized = {} } = signatureResp;
                  const isEn = i18n.language === "en";
                  const label = signatureResp.documentSignatureId
                    ? isEn
                      ? signatureResp.documentTypeNameEn
                      : signatureResp.documentTypeName
                    : signatureResp.documentTypeName;

                  return (
                    <>
                      <label>{idx === 0 ? label : ""}</label>
                      <p>
                        {authorized.id ? t("document.label.authorized") : "-"}
                      </p>
                      <Button
                        onClick={() => onView(signatureResp)}
                        disabled={!signatureResp.documentSignatureId}
                        type="primary"
                        style={{ backgroundColor: !signatureResp.documentSignatureId ? "" : "var(--button-color)" }}
                      >
                        {t("action.view")}
                      </Button>
                    </>
                  );
                });
              })}
            </div>
          </Card>
        </Space>
      </Spin>
    </>
  );
}

export default CompanyDocumentView;
